var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueConfirmationModal',{attrs:{"modal-id":_vm.modalId,"heading-text":_vm.headingText,"namespace":(_vm.namespace + "/recycle")},on:{"confirmed-modal":_vm.recycle}})}
var staticRenderFns = []

export { render, staticRenderFns }